import { Cobranded } from "@components/common/Cobranded";
import { mergeGetStaticProps } from "@lib/mergeStaticProps";
import { getPartnerStaticProps } from "@lib/partner";
import BudgetCheckPage, {
  getStaticProps as originalGetStaticProps,
} from "@pages/compare/budget-check/[stepId]";

const PartnerBudgetCheckPage = ({ partner, stepId, ...props }) => {
  return (
    <Cobranded partner={partner}>
      <BudgetCheckPage stepId={stepId} {...props} />
    </Cobranded>
  );
};

export const getStaticPaths = () => {
  return { paths: [], fallback: "blocking" };
};

export default PartnerBudgetCheckPage;

export const getStaticProps = mergeGetStaticProps(
  getPartnerStaticProps,
  originalGetStaticProps,
);
